export default __webpack_public_path__ + "static/media/7.644b83df.png";